import { en } from './en'
import { fr } from './fr'

export const noticeBanner = {
  en,
  fr
}